import { SxProps, Theme } from '@mui/material';

export const styles: Record<'headerButtons' | 'checkbox' | 'content' | 'addTag', SxProps<Theme>> = {
  addTag: {
    '&:hover': {
      background: (theme) => theme.palette.gray['100'],
    },
    backgroundColor: (theme) => theme.palette.gray['50'],
    borderRadius: '8px',
    cursor: 'pointer',
    marginBottom: (theme) => theme.spacing(3),
    padding: (theme) => theme.spacing(2),
  },
  checkbox: {
    '& + &': {
      borderTop: (theme) => `1px solid ${theme.palette.gray['200']}`,
    },
    '&:hover': {
      background: (theme) => theme.palette.gray['100'],
    },
    '.MuiFormControlLabel-label': {
      flexGrow: 1,
    },
    borderRadius: '4px',
    margin: 0,
    minWidth: '296px',
    padding: 2,
    width: '100%',
  },
  content: {
    background: (theme) => theme.palette.gray['50'],
    borderRadius: '8px',
    overflow: 'hidden',
  },
  headerButtons: {
    position: { sm: 'absolute' },
    right: (theme) => ({
      sm: theme.spacing(1),
      xxs: theme.spacing(2),
    }),
  },
};
